/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Open_ActionInputs */

const en_us2_search_open_action = /** @type {(inputs: Search_Open_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do it now`)
};

const pt_br2_search_open_action = /** @type {(inputs: Search_Open_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer agora`)
};

const es_419_search_open_action = /** @type {(inputs: Search_Open_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hacerlo ahora`)
};

const pt_pt2_search_open_action = /** @type {(inputs: Search_Open_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer agora`)
};

const fr_fr2_search_open_action = /** @type {(inputs: Search_Open_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le faire maintenant`)
};

const de_de2_search_open_action = /** @type {(inputs: Search_Open_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt erledigen`)
};

const it_it2_search_open_action = /** @type {(inputs: Search_Open_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallo ora`)
};

/**
* | output |
* | --- |
* | "Do it now" |
*
* @param {Search_Open_ActionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_open_action = /** @type {((inputs?: Search_Open_ActionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Open_ActionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_open_action(inputs)
	if (locale === "es-419") return es_419_search_open_action(inputs)
	if (locale === "pt-PT") return pt_pt2_search_open_action(inputs)
	if (locale === "fr-FR") return fr_fr2_search_open_action(inputs)
	if (locale === "de-DE") return de_de2_search_open_action(inputs)
	if (locale === "it-IT") return it_it2_search_open_action(inputs)
	return en_us2_search_open_action(inputs)
});
export { search_open_action as "search.open_action" }